/**
 * LegacyRedirect — Navigate that PRESERVES the incoming query string.
 *
 * The static `<Navigate to="/account?tab=integrations">` redirects silently
 * dropped incoming params — which ate the Meta/Shopify OAuth callback results
 * (?status=success / ?error=meta_account_mismatch land on
 * /settings/integrations, the redirect stripped them, and no toast ever
 * fired). Params from the target win over same-named incoming ones.
 */
import { Navigate, useLocation } from 'react-router-dom';

export function LegacyRedirect({ to }: { to: string }): JSX.Element {
  const location = useLocation();
  const [targetPath, targetQuery] = to.split('?');
  const merged = new URLSearchParams(location.search);
  if (targetQuery) {
    for (const [key, value] of new URLSearchParams(targetQuery)) {
      merged.set(key, value);
    }
  }
  const query = merged.toString();
  return <Navigate to={query ? `${targetPath}?${query}` : targetPath} replace />;
}
